import React from 'react';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent } from '@mui/material';

import useStatusChange from './useStatusChange';
import { StatusSelect, ReturnReason } from './components';

const ChangeStatus = ({ open = false, handleClose, currentStatus, appInstId }) => {
    const { statuses, doingAjax, retrieveStatuses, changeStatus } = useStatusChange(appInstId, currentStatus);
    const [selectedStatus, setSelectedStatus] = React.useState('');
    const [returnReason, setReturnReason] = React.useState('');

    React.useEffect(() => {
        retrieveStatuses();
    }, [currentStatus]);

    const handleSave = async () => {
        if (await changeStatus(selectedStatus, returnReason)) handleClose?.(true);
    };

    const handleCancel = async () => {
        handleClose?.();
    };

    return (
        <Dialog open={open}>
            <DialogTitle>Edit application status</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography>Select a new status and click the "Save changes" button to edit the status of the application.</Typography>

                    <StatusSelect
                        statuses={statuses}
                        selectedStatus={selectedStatus}
                        setSelectedStatus={setSelectedStatus}
                    />

                    <ReturnReason
                        selectedStatus={selectedStatus}
                        returnReason={returnReason}
                        setReturnReason={setReturnReason}
                    />
                </Box>

                <Box>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleCancel}
                        disabled={doingAjax}
                    >
                        <Typography>Cancel</Typography>
                    </Button>

                    <Button
                        variant="contained"
                        disabled={
                            selectedStatus === '' || ((selectedStatus === 3 || selectedStatus === 7) && returnReason === '') || doingAjax
                        }
                        onClick={handleSave}
                    >
                        <Typography>Save changes</Typography>
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ChangeStatus;
